import { render, staticRenderFns } from "./Technology.vue?vue&type=template&id=649e46e2&scoped=true&"
import script from "./Technology.vue?vue&type=script&lang=js&"
export * from "./Technology.vue?vue&type=script&lang=js&"
import style0 from "./Technology.vue?vue&type=style&index=0&id=649e46e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e46e2",
  null
  
)

export default component.exports